import { createListFilters, IOption } from '../../../../../components'

export type SignAsoFilters = {
  protocolo: string
  /** Primeiro nome do paciente (busca parcial). */
  paciente: string
  estado?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<SignAsoFilters>({
  protocolo: '',
  paciente: '',
  estado: undefined,
})
